import { Permissions, getIsAdfenixToken, getUserPermissions } from "atoms/auth";
import { useCallback, useEffect, useState } from "react";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";

import { hasAction } from "utils/hasAction";
import { useRecoilValue } from "recoil";

export const useNavigateByRole = () => {
  const permissions = useRecoilValue(getUserPermissions);
  const isAdfenixToken = useRecoilValue(getIsAdfenixToken);

  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const [hasNavigated, setHasNavigated] = useState(false);

  const navigateByRole = useCallback(
    (permissions: Permissions) => {
      if (
        (location.pathname.includes("login") || location.pathname === "/") &&
        permissions &&
        !isAdfenixToken
      ) {
        const returnUrl = searchParams.get("returnUrl");

        if (returnUrl) {
          navigate(decodeURIComponent(returnUrl));
        } else if (permissions.Admin.some(hasAction("Edit"))) {
          navigate("/back-office/campaign");
        } else {
          navigate("/property/list");
        }

        setHasNavigated(true);
      }
    },
    [navigate, isAdfenixToken, location.pathname, searchParams]
  );

  useEffect(() => {
    if (permissions) {
      navigateByRole(permissions);
    }
  }, [navigateByRole, permissions]);

  return hasNavigated;
};
